export default __webpack_public_path__ + "static/media/swap.2ef4387d.svg";